// Sesso dal codice fiscale (giorno di nascita +40 per le donne).
export function sessoFromCF(cf) {
  const s = String(cf || "").trim().toUpperCase();
  if (!/^[A-Z]{6}[0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{3}[A-Z]$/.test(s)) return "";
  const map = { L: 0, M: 1, N: 2, P: 3, Q: 4, R: 5, S: 6, T: 7, U: 8, V: 9 };
  const day = parseInt(s.slice(9, 11).split("").map((c) => (c in map ? map[c] : c)).join(""), 10);
  return day > 40 ? "Femmina" : "Maschio";
}

// Applica il cambio campo e, se è un CF valido, aggiorna anche il sesso.
export function withCfSesso(obj, key, val) {
  const next = { ...obj, [key]: val };
  if (key === "codice_fiscale") {
    const s = sessoFromCF(val);
    if (s) next.sesso = s;
  }
  return next;
}
